const disableYouTubeCaptions = (player) => {
    player.mute();

    try {
        player.setOption('captions', 'track', {});

        if (typeof player.unloadModule === 'function') {
            player.unloadModule('captions');
        }
    } catch (error) {
        // The captions module may already be absent, which is the desired state.
    }
};

export const startHero = () => {
    const youtubeFrames = document.querySelectorAll(
        '.start-hero__embed iframe[src*="youtube.com"], .start-hero__embed iframe[src*="youtu.be"]'
    );

    document.querySelectorAll('.start-hero__embed iframe[src*="vimeo.com"]').forEach((frame) => {
        const disableCaptions = () => {
            frame.contentWindow?.postMessage(
                JSON.stringify({ method: 'disableTextTrack' }),
                'https://player.vimeo.com'
            );
        };

        frame.addEventListener('load', disableCaptions);
        disableCaptions();
    });

    if (!youtubeFrames.length) {
        return;
    }

    const initialisePlayers = () => {
        youtubeFrames.forEach((frame) => {
            if (frame.dataset.youtubePlayerReady) {
                return;
            }

            frame.dataset.youtubePlayerReady = 'true';

            new window.YT.Player(frame, {
                events: {
                    onReady: ({ target }) => {
                        disableYouTubeCaptions(target);
                        target.playVideo();
                    },
                    onStateChange: ({ target }) => {
                        disableYouTubeCaptions(target);
                    },
                },
            });
        });
    };

    if (window.YT?.Player) {
        initialisePlayers();
        return;
    }

    const previousReadyHandler = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
        previousReadyHandler?.();
        initialisePlayers();
    };

    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        document.head.append(script);
    }
};
